<template>
  <v-card v-if="params" class="ticket-card">
    <v-card-title>
      <div class="pt-headline ticket-card__title support--color">
        <p class="ticket-card__title">
          #{{ item.number }} | {{ item.summary }}
        </p>
      </div>
      <div
        :style="{ backgroundColor: params.color }"
        class="ticket-card__status"
      >
        <i :class="`bexsicon-${params.icon}`" />
        {{ params.title }}
      </div>
    </v-card-title>
    <v-card-text>
      <div class="ticket-card__subtitle">
        <!-- <v-layout align-start justify-start column > -->
        <v-flex
          >Data de abertura:
          {{ this.formatDate(item.openDate) }}
        </v-flex>
        <v-flex class="ticket-card__requester" v-if="forDetails">
          <v-layout align-start justify-start row wrap>
            Solicitante:
            <div class="ticket-card__requester__name">
              {{ formatRequesterName(item.requesterName) }}
            </div>
            ({{ item.requesterMail }})
          </v-layout>
        </v-flex>
        <!-- </v-layout> -->
      </div>
      <div
        v-if="!forDetails"
        class="ticket-card__description"
        v-html="content"
      ></div>
    </v-card-text>
    <v-card-actions v-if="!forDetails">
      <v-btn class="support--color btn-md" @click="$emit('edit', item)">
        <i class="bexsicon-request mx-1" />
        <span>Solicitação completa</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ticket-card',
  props: {
    item: {
      type: Object,
      required: true,
    },
    statusParams: {
      type: Object,
      required: true,
    },
    forDetails: Boolean,
  },
  computed: {
    content() {
      return this.item.descriptionAsText || '';
    },
    params() {
      return this.statusParams[this.item.currentStatusName];
    },
  },
  methods: {
    formatRequesterName(v) {
      const names = v.split(' ');
      if (names.length > 1) {
        return `${names[0]} ${names[names.length - 1]}`.toLowerCase();
      } else {
        return names[0].toLowerCase();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

>>> .v-card__title {
  padding-bottom: 0;
}

.ticket-card {
  margin: 15px;
  .pt-headline {
    @include breakpoint(mobile) {
      font-size: 1.2em !important;
    }
  }

  @include breakpoint(mobile) {
    font-size: 1em;
  }

  &__title {
    display: flex;
    word-break: break-word;
    flex: 0.88;
    margin-bottom: 18px;
    @include breakpoint(mobile) {
      margin-top: 10px;
      margin-bottom: 0;
      flex: 1;
    }
  }

  &__number {
    flex: 0.1;
  }

  &__divider {
    border-left: solid;
    border-width: 1px;
    margin: auto 15px;
    flex: 0.01;
  }

  .divider--lg {
    height: 19px;
    border-width: 1.5px;
    @include breakpoint(mobile) {
      margin: 10px;
    }
  }

  .divider--sm {
    height: 14px;
    border-width: 1px;
    @include breakpoint(mobile) {
      display: none;
    }
  }

  &__summary {
    flex: 0.89;
  }

  &__status {
    position: absolute;
    font-size: 0.8em;
    text-align: center;
    color: #fff;
    padding: 2.5px 15px;
    border-radius: 10px;
    @include breakpoint(not-mobile) {
      right: 10px;
    }
    @include breakpoint(mobile) {
      left: 10px;
      top: 10px;
    }

    i {
      font-size: 0.8em;
      padding: 0 0.25em;
    }
  }

  &__subtitle {
    font-size: 0.8em;
    color: var(--light-dark-color);
    margin-top: -5%;
    // display: flex;
  }

  &__requester {
    padding: 0 0px;
    // display: flex;
    @include breakpoint(mobile) {
      display: block;
      font-size: 1.2em;
    }

    &__name {
      padding: 0 5px;
      text-transform: capitalize;
    }
  }

  &__description {
    margin-top: 2.5%;
    font-size: 0.85em;
    color: var(--light-dark-color);
    overflow-wrap: break-word;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/support/TicketCard.vue